import { storedDayAsUtcString, todayUtcString } from '@/utils/date';

import type { LicenseStatus } from './LicenseStatusBadge';

/** Whether today falls before, inside or after the licence's stored From and To days (UTC). */
export function getLicenseStatus(dayFrom: string, dayTo: string): LicenseStatus {
    const todayStr = todayUtcString();
    const from = storedDayAsUtcString(dayFrom);
    const to = storedDayAsUtcString(dayTo);

    if (from && from > todayStr) {
        return 'upcoming';
    }

    if (to && to < todayStr) {
        return 'expired';
    }

    return 'active';
}
